import { render } from "./fieldDuration.vue?vue&type=template&id=74a48a5a"
import script from "./fieldDuration.vue?vue&type=script&lang=js"
export * from "./fieldDuration.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__